import React, { useState } from 'react';
import './Contact.css';

const courseOptions = [
  'Mathematics (Class 6-12)',
  'Science (Class 6-12)',
  'English (Class 6-12)',
  'Physics (Class 11-12)',
  'Chemistry (Class 11-12)',
  'Social Science (SST)',
  'Computers',
  'Hindi',
  'Sanskrit',  
];

const contactInfo = [
  { icon: '📍', label: 'Address', value: '2nd A - 23, Nehru Nagar II, Nehru Nagar, Ghaziabad, Uttar Pradesh 201001' },
  { icon: '📞', label: 'Phone', value: '+91 88004 69527' },
  { icon: '🕐', label: 'Hours', value: 'Open 24 Hours' },
];

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', course: '', message: '' });
  const [status, setStatus] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setStatus(null);
    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (data.success) {
        setStatus({ type: 'success', message: data.message });
        setForm({ name: '', email: '', phone: '', course: '', message: '' });
      } else {
        setStatus({ type: 'error', message: data.message || 'Something went wrong. Please try again.' });
      }
    } catch {
      setStatus({ type: 'error', message: 'Unable to connect. Please try again later.' });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="contact">
      <div className="contact__container">
        <h2 className="section-title">Get In Touch</h2>
        <div className="section-divider"></div>
        <p className="section-subtitle">
          Ready to start your academic journey? Reach out to us and we'll help you find the right course.
        </p>
        <div className="contact__grid">
          <div className="contact__form-wrap">
            <h3 className="contact__form-title">Send Us a Message</h3>
            {status && (
              <div className={`contact__alert contact__alert--${status.type}`}>
                {status.type === 'success' ? '✅' : '❌'} {status.message}
              </div>
            )}
            <form className="contact__form" onSubmit={handleSubmit} noValidate>
              <div className="contact__form-row">
                <div className="contact__field">
                  <label htmlFor="name">Full Name *</label>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    placeholder="Your full name"
                    value={form.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="contact__field">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    placeholder="your@email.com"
                    value={form.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
              <div className="contact__form-row">
                <div className="contact__field">
                  <label htmlFor="phone">Phone Number</label>
                  <input
                    id="phone"
                    name="phone"
                    type="tel"
                    placeholder="+91 XXXXX XXXXX"
                    value={form.phone}
                    onChange={handleChange}
                  />
                </div>
                <div className="contact__field">
                  <label htmlFor="course">Select Course</label>
                  <select
                    id="course"
                    name="course"
                    value={form.course}
                    onChange={handleChange}
                  >
                    <option value="">Choose a course...</option>
                    {courseOptions.map((c) => (
                      <option key={c} value={c}>{c}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="contact__field">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  rows={4}
                  placeholder="Tell us about your requirements..."
                  value={form.message}
                  onChange={handleChange}
                  required
                />
              </div>
              <button
                type="submit"
                className="contact__submit"
                disabled={submitting}
              >
                {submitting ? 'Sending...' : 'Send Message →'}
              </button>
            </form>
          </div>

          <div className="contact__info">
            <h3 className="contact__info-title">Contact Information</h3>
            <div className="contact__info-list">
              {contactInfo.map((item) => (
                <div key={item.label} className="contact__info-item">
                  <div className="contact__info-icon">{item.icon}</div>
                  <div>
                    <div className="contact__info-label">{item.label}</div>
                    <div className="contact__info-value">{item.value}</div>
                  </div>
                </div>
              ))}
            </div>
            <div className="contact__social">
              <h4>Follow Us</h4>
              <div className="contact__social-links">
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="contact__social-btn contact__social-btn--fb">
                  📘 Facebook
                </a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="contact__social-btn contact__social-btn--ig">
                  📷 Instagram
                </a>
                <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="contact__social-btn contact__social-btn--yt">
                  ▶️ YouTube
                </a>
              </div>
            </div>
            <div className="contact__map-placeholder">
              <span>🗺️</span>
              <p>2nd A - 23, Nehru Nagar II<br />Nehru Nagar, Ghaziabad<br />Uttar Pradesh 201001</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
